import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import { GridApi, DataGridPro, useGridApiRef, GridActionsCellItem } from '@mui/x-data-grid-pro';

import {Button, Box, Typography, 
  Dialog, DialogTitle, DialogContent, DialogActions, IconButton,
  MenuItem, Select, Snackbar, Tooltip} from '@mui/material';

import Grid2 from '@mui/material/Unstable_Grid2/Grid2';

import { useRef, useState, useEffect, useCallback, useMemo } from 'react';
// import Paper from 'src/theme/overrides/Paper';
import { Icon as Iconify } from '@iconify/react';


import {TransformDataForGrid}  from './helpers';
import {ccColorDarkTeal, ccColorOrange, ccColorSecondaryPink, lionObjectsColors}  from './helpersStyles';
import {lionIcons}  from './helpersIcons';
import { CcLoader, InfoToolTip } from '../commonComponents/generalComponents';
import { CCCustomFooter } from "../components/helperDataGrid";
import { InputText } from '../commonComponents/inputFields';
import { CcActionButton, CcActionButtonOutlined, CcSecondaryActionButtonOutlined } from '../commonComponents/styledTexts';
import Papa from "papaparse";
import { getErrorListFromYupError, getErrorMessage, nearestStoresFileValidationSchema } from '../components/helperErrors'
import { ExclamationCircleIcon } from '@heroicons/react/20/solid';
import CcMapPointers from '../commonComponents/ccMap';

function FilePicker({
  accept = ".csv",
  buttonText = "Choose File",
  onFileSelected,
  error,
}) {
  const inputRef = useRef(null);
  const [fileName, setFileName] = useState("");

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    setFileName(file.name);
    onFileSelected?.(file);
  };

  return (
    <div className="flex items-center gap-4">
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        onChange={handleChange}
        className="hidden"
      />

			<CcActionButton onClick={handleClick}>{buttonText}</CcActionButton>
      {error?.length > 0 ?
        <div className='flex flex-row items-center gap-x-1'>
              <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
              <div className=" text-sm text-red-600">{error}</div>
        </div>
      :
      <span className="truncate text-sm text-gray-600">
        {fileName || "No file selected"}
      </span>
    }
    </div>
  );
}

export default function NearestStoreFilesGrid(props) {
  /*
  props:

  */
  const apiRef = useGridApiRef();
  const apiRefStoresData = useGridApiRef();
  const apiRefStores = useGridApiRef();
  const navigate = useNavigate();

  const allColumns = [
    { field: 'name', headerName: 'Name', width: props.mini ? 220 : 200 },
    { field: 'desc', headerName: 'Description', width: 200 },
    { field: 'created', headerName: 'Created', width: 120,
      valueFormatter: (params) => {
        if (params.value == null) return '';
        const date = new Date(Date.parse(params.value))
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth is zero-based
        const day = String(date.getDate()).padStart(2, '0');

        return `${day}/${month}/${year}`;        
        //return new Date(Date.parse(params.value)).toLocaleString();
      } },
    { field: 'numStores', headerName: 'Num Stores', width: 120 },
    
  ];
  if (props.noActions) {}
  else {
    allColumns.push({
          field: 'actions',
          type: 'actions',
          width: 180,
          align: 'right',      
          getActions: (params) => {
            const actions = [
            <Tooltip title='Manage stores' placement='top'><GridActionsCellItem icon={<Iconify icon='material-symbols:manage-search' width={20} />} onClick={() => (openDialog_ManageStores(params.id))} label="Edit" disabled={params.row.status === 'PENDING CHANGES'} /></Tooltip>,
            <Tooltip title='Upload new file' placement='top'><GridActionsCellItem icon={<Iconify icon='material-symbols:upload' width={20} />} onClick={() => openDialog_UpdateStoresFile(params.row)} label="Upload new file"  /></Tooltip>,
            ]
            if (params.row.feedType === 'CATALOG') actions.unshift(<Tooltip title='Edit custom columns' placement='top'><GridActionsCellItem icon={<Iconify icon='fluent-mdl2:insert-columns-right' width={20} />} onClick={() => (window.location.href = `/catalogs/customColumns/${params.id}`)} label="Edit" /></Tooltip>)
            return actions;
          }
        })
  }
  const storesColumns = [
    { field: 'id', headerName: 'Store Id', width: 140 },
    { field: 'storeName', headerName: 'Store Name', width: 140, editable: true },
    { field: 'address1', headerName: 'Address 1', width: 140, editable: true },
    { field: 'address2', headerName: 'Address 2', width: 140, editable: true },
    { field: 'city', headerName: 'City', width: 140, editable: true },
    { field: 'country', headerName: 'Country', width: 140, editable: true },
    { field: 'latitude', headerName: 'Latitude', width: 140, editable: true },
    { field: 'longitude', headerName: 'Longitude', width: 140, editable: true },
    { field: 'custom1', headerName: 'Custom 1', width: 140, editable: true },
    { field: 'custom2', headerName: 'Custom 2', width: 140, editable: true },
    { field: 'custom3', headerName: 'Custom 3', width: 140, editable: true },
    {
      field: 'actions',
      type: 'actions',
      width: 90,
      align: 'right',      
      getActions: (params) => {
        const actions = [
        <Tooltip title='Edit store' placement='top'><GridActionsCellItem icon={<Iconify icon={lionIcons.Icon_Actions_Edit} width={20} color={ccColorDarkTeal} />} onClick={() => (handleStartEditRow(params.id))} label="Edit" disabled={params.row.status === 'PENDING CHANGES'} /></Tooltip>,
        <Tooltip title='Delete store' placement='top'><GridActionsCellItem icon={<Iconify icon={lionIcons.Icon_Actions_Delete} width={20} color={ccColorDarkTeal} />} onClick={() => handleDeleteStore(params.id)} label="Delete"  /></Tooltip>,
        ]
        if (params.row.feedType === 'CATALOG') actions.unshift(<Tooltip title='Edit custom columns' placement='top'><GridActionsCellItem icon={<Iconify icon='fluent-mdl2:insert-columns-right' width={20} />} onClick={() => (window.location.href = `/catalogs/customColumns/${params.id}`)} label="Edit" /></Tooltip>)
        return actions;
      }
    },
  ]


  const [data, setData] = useState([]);
  const [stores, setStores] = useState([]);
  const [columns, setColumns] = useState(allColumns);
  const dialogDataCreate = {action: 'new', id:'', title:'Create new Stores File', desc:''}
  const storesFileEmpty = {storesFileId: undefined, name:'', desc:'', columnMapping: {}, delimiter: '' }
  const storesFilePreviewDataEmpty = {columns: [], rows: []}
  const [currentStoresFile, setCurrentStoresFile] = useState(storesFileEmpty);
  const [currentStoresFilePreviewData, setCurrentStoresFilePreviewData] = useState(storesFilePreviewDataEmpty);
  const [dialogManageStoresFileId, setDialogManageStoresFileId] = useState(undefined);
  const [dialogManageStoreId, setDialogManageStoreId] = useState(0);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState({action: '', id:'', title:'', desc:''});
  const [dialogManageStoresOpen, setDialogManageStoresOpen] = useState(false);
  const [dialogConfirmDeleteStoreOpen, setDialogConfirmDeleteStoreOpen] = useState(false);
  const [dataIsLoading, setDataIsLoading] = useState(false)
  const [storesAreLoading, setStoresAreLoading] = useState(false)
  const [activeErrorList, setActiveErrorList] = useState([]);
  const [storesFileUpdating, setStoresFileUpdating] = useState(false)
  const [storesFileShowUpdateResult, setStoresFileShowUpdateResult] = useState(true)
  const [storesFileUpdateResults, setStoresFileUpdateResults] = useState(undefined)
  const [highlightedRowIds, setHighlightedRowIds] = useState(null);

const getData = useCallback(async () => {
    try {
      setDataIsLoading(true)
      const url = `${process.env.REACT_APP_LION_API_URL}/Stores/getFiles`;
      const response = await axios.get(url);

      // const url = `api/Feeds`;
      //const url = `${process.env.NEXT_PUBLIC_NEXT_API_URL}/Feeds`;

      //const response = await fetch(url, { method: "GET", });
  
      //const data = await response.json();
      const data = response.data;

      setData(TransformDataForGrid(data, 'storesFileId'));

    } catch (error) {
      console.log(error);
    }
    finally {setDataIsLoading(false)}
  }
  ,[])

useEffect(() => {getData()}, [getData]);
useEffect(() => {if (props.createNew) openDialog_UpdateStoresFile()}, [props.createNew])
useEffect(() => {
    if (props.selectedFileId !== undefined) {
      apiRef.current.selectRow(props.selectedFileId);
    }
}, [props.selectedFileId])

const getStores = async (storesFileId) => {
    try {
      const url = `${process.env.REACT_APP_LION_API_URL}/Stores/getStores/${storesFileId}`;
      const response = await axios.get(url);

      const data = response.data;
      setStores(TransformDataForGrid(data, 'storeId'));


    } catch (error) {
      console.log(error);
    }
    finally {setStoresAreLoading(false)}
  }
const updateStore = async (row) => {
    try {
      //console.log(dialogManageStoresFileId)
      const url = `${process.env.REACT_APP_LION_API_URL}/Stores/updateStore/${dialogManageStoresFileId}`;
      const response = await axios.post(url, {...row, storeId: row.id});

      const data = response.data;

      return data


    } catch (error) {
      console.log(error);
    }
    finally {setStoresAreLoading(false)}
  }
const deleteStore = async (storeId) => {
    try {
      //console.log(storeId)
      const url = `${process.env.REACT_APP_LION_API_URL}/Stores/delete/${dialogManageStoresFileId}?id=${storeId}`;
      const response = await axios.get(url)

      const data = response.data;

      return data


    } catch (error) {
      console.log(error);
    }
    finally {setStoresAreLoading(false)}
  }


const [snackBarClipboardOpen, setSnackBarClipboardOpen] = useState(false);
const handleCloseSnackBarClipboard = () => {
    setSnackBarClipboardOpen(false);
}
const SnackBarAction = (
    <>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleCloseSnackBarClipboard}
      >
        <Iconify icon={lionIcons.Icon_Actions_Cancel} />
      </IconButton>
    </>
  );



      
const createStoresFile = async () => {
  try {
    const formData = new FormData();

    // These names must match the ASP.NET model properties.
    formData.append("file", file);
    formData.append("name", currentStoresFile.name);
    formData.append("desc", currentStoresFile.desc);
    formData.append("delimiter", currentStoresFile.delimiter);
    if (currentStoresFile.storesFileId) formData.append("storesFileId", currentStoresFile.storesFileId);
    formData.append("columnMapping", JSON.stringify(currentStoresFile.columnMapping));


    let url = `${process.env.REACT_APP_LION_API_URL}/Stores/createStoresFile/`;
    if (currentStoresFile.storesFileId) url = `${process.env.REACT_APP_LION_API_URL}/Stores/updateStoresFile`;

    //const dataToPost = {...currentStoresFile, file: file, columnMapping: JSON.stringify(currentStoresFile.columnMapping)}
    //const response = await axios.post(url, dataToPost);
    const response = await axios.post(url, formData);
    setStoresFileUpdateResults(response.data)

        
  } catch (error) {
    console.log(error);
  }

}
const handleDialogClose = async (action) => {
  if (action === 'upload') {
      const isValid = validateCurrentNearestStore()
      if (!isValid) return
      setStoresFileUpdating(true)
      updateDialogData('showCloseButton', true)
      await createStoresFile()
      setStoresFileUpdating(false)
      setStoresFileShowUpdateResult(true)

    // re-download data to refresh the grid
    getData();

  }
  else {
    setDialogData({action: '', id:'', title:'', desc:''});
    setDialogOpen(false);
  }
  if (props.onFileChange) props.onFileChange({action: action})
}
const handleDialogManageStoresClose = async (action) => {
  setDialogManageStoresOpen(false)
  setStoresAreLoading(false)
}
const handleDialogDeleteStoreClose = async (action) => {
  if (action === 'confirm') {
    const success = await deleteStore(dialogManageStoreId)
    if (success) {
        apiRefStores.current.updateRows([{ id: dialogManageStoreId, _action: 'delete' },])

    }
  }
  setDialogConfirmDeleteStoreOpen(false)
  
}

const NoRowsCustomMessage = (props) => {
  return <div className='flex flex-col gap-6 items-center mt-16'>
            <div>No stores files found in your account yet</div>
            <button type="button" className={`focus:outline-none text-white bg-ccColorSecondaryPink hover:bg-ccColorSecondaryPurple font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-900 ${props.className}`}
                    onClick={() => openDialog_UpdateStoresFile()}
            >
              <div className='flex flex-row gap-2 items-center font-poppins'>
                <Iconify icon={lionIcons.Icon_Actions_Add} width={26} />
                Upload a new Stores File
              </div>
            </button>
          </div>
}
const openDialog_UpdateStoresFile = (editRow) => {
  setDialogData(dialogDataCreate);
  setCurrentStoresFile(storesFileEmpty);
  setCurrentStoresFilePreviewData(storesFilePreviewDataEmpty);
  setActiveErrorList([]);
  setStoresFileUpdating(false)
  setStoresFileShowUpdateResult(false)
  setLatLongs([])
  setWrongLatLongs([])
  setHighlightedRowIds(null)

  setDialogOpen(true)
  if (editRow) {
    const newCurrentStoresFile = {...currentStoresFile, name: editRow.name, desc: editRow.desc, storesFileId: editRow.id}
    setCurrentStoresFile(newCurrentStoresFile)
  }
}
const openDialog_ManageStores = (storesFileId) => {
  setStoresAreLoading(true)
  setDialogManageStoresOpen(true)
  setDialogManageStoresFileId(storesFileId)
  getStores(storesFileId)
}
const updateDialogData = (propName, propValue) => {
  const newDialogData = {...dialogData, [propName]: propValue}
  setDialogData(newDialogData)
}

const CustomLoader = () => {
  return <div className='flex flex-col gap-4 items-center justify-center mt-16'>
    <CcLoader />
    <div>Loading...</div>
  </div>
}

const [file, setFile] = useState(null);
const predefinedFields = [{id: 'cc-ignore', name: 'Ignore'},
  {id: 'storeId', name: 'Store Id'},
  {id: 'latitude', name: 'Latitude'},
  {id: 'longitude', name: 'Longitude'},
  {id: 'storeName', name: 'Store Name'},
  {id: 'address1', name: 'Address Line 1'},
  {id: 'address2', name: 'Address Line 2'},
  {id: 'city', name: 'City'},
  {id: 'country', name: 'Country'},
  {id: 'cc-custom1', name: 'Custom1'},
  {id: 'cc-custom2', name: 'Custom2'},
  {id: 'cc-custom3', name: 'Custom3'},
];
const handleFileSelected = (selectedFile) => {
    setFile(selectedFile);

    Papa.parse(selectedFile, {
      header: true,
      skipEmptyLines: true,
      complete: ({ data, meta }) => {
        if (activeErrorList.length > 0) validateCurrentNearestStore({...currentStoresFile, file: selectedFile})

				const cols = meta.fields.map(f => ({field: f, headerName: f}))
				const rows = data.map((row, index) => ({id: index + 1, ...row}));

				//console.log(rows)
				handleStoresFileChangePreviewData(rows, cols)
        handleStoresFileChange('delimiter', meta.delimiter, true)
      },
    });

  };
const handleStoresFileChange = (propName, propValue, clearMapping) => {
	const newStoreFile = {...currentStoresFile, [propName]: propValue}
  if (clearMapping) {
    newStoreFile.columnMapping = {}
    setLatLongs([])
    setWrongLatLongs([])
    setHighlightedRowIds(null)
  }
	setCurrentStoresFile(newStoreFile)
  if (activeErrorList.length > 0) validateCurrentNearestStore(newStoreFile)
}
const handleStoresFileChangePreviewData = (rows, cols) => {
	const newStoreFilePreviewData = {...currentStoresFilePreviewData, rows: rows, columns: cols}
	setCurrentStoresFilePreviewData(newStoreFilePreviewData)
}
const handleCurrentStoresFileMappingChange = (columnId, val) => {
  const newMappings = {...currentStoresFile.columnMapping, [columnId]: val}
  const newStoresFile = {...currentStoresFile, columnMapping: newMappings}
  setCurrentStoresFile(newStoresFile)
  
  //check we have a mapping for BOTH lat and long
  let latFound = undefined
  let longFound = undefined
  for (const prop of Object.keys(newMappings)) {
    if (newMappings[prop] === 'latitude') latFound = prop
    if (newMappings[prop] === 'longitude') longFound = prop
  }
  if (latFound && longFound) {
      const values = []
      const wrongs = []
      apiRefStoresData.current.getRowModels().values().forEach(row => {
      const lat = row[latFound]
      const long = row[longFound]
      if (isValidLatLng(lat, long)) values.push({lat: lat, lng: long})
      else {
        wrongs.push({id: row.id, lat: lat, lng: long})
      }
    });
    
    setLatLongs(values)
    setHighlightedRowIds(wrongs.map(w => w.id))
    setWrongLatLongs(wrongs)
    if (wrongs.length > 0) {
      const rowIndex = apiRefStoresData.current.getRowIndexRelativeToVisibleRows(wrongs[0].id);
      apiRefStoresData.current.scrollToIndexes({ rowIndex });      
    }
  }
  else {
    setLatLongs([])
    setWrongLatLongs([])
    setHighlightedRowIds(null)
  }

}
const validateCurrentNearestStore = (obj) => {
    try {
      //console.log(snippetData)
      const objToValidate = obj ? obj : {...currentStoresFile, file: file}
      nearestStoresFileValidationSchema.validateSync(objToValidate, {abortEarly: false});
      setActiveErrorList([])
      return true
    }
    catch (e) {
      console.log(JSON.parse(JSON.stringify(e)))
      const errorList = getErrorListFromYupError(e)
      setActiveErrorList(errorList)
      return false;
    }
}
const getAvailablePredefinedFields = (addValue) => {
  const result = [...predefinedFields]
  for (const key of Object.keys(currentStoresFile.columnMapping)) {
    const val = currentStoresFile.columnMapping[key]
    if (val === 'cc-ignore') continue
    const index = result.findIndex(f => f.id === val)
    result.splice(index, 1)
  }
  if (addValue) {
    const index = result.findIndex(f => f.id === addValue)
    if (index === -1) {
      const itemToAdd = predefinedFields.find(f => f.id === addValue)
      result.push(itemToAdd)
    }
  }
  return result
}

const previewColumns = useMemo(() => {
  if (activeErrorList.length > 0) validateCurrentNearestStore()
  
  return currentStoresFilePreviewData.columns.map((csvColumn) => ({
    field: csvColumn.field,
    sortable: false,
    width: 180,
    renderHeader: () => (
      <Box sx={{ display: "flex", flexDirection: "column" }}>
         <Typography variant="caption" fontWeight="bold">
            {csvColumn.field}
          </Typography>


        <Select
          size="small"
          value={currentStoresFile.columnMapping[csvColumn.field] ?? "cc-ignore"}
          onChange={(e) => handleCurrentStoresFileMappingChange(csvColumn.field, e.target.value)}
          onClick={(event) => event.stopPropagation()}
          sx={{ fontSize: 12, height: 28, width: 150, outline: 'none' }}
        >
          
          {getAvailablePredefinedFields(currentStoresFile.columnMapping[csvColumn.field]).map(f => (f.id.startsWith('cc-custom') ? <MenuItem value={f.id}><div className='flex flex-row items-center gap-x-1 text-ccColorDarkTeal'>
                                        <div>{f.name}</div>
                                        <InfoToolTip 
                                          placement='left'
                                          headLine='Custom field'
                                          message="You can use this custom field to save extra data of your stores and use them in your templates"
                                        />
                                      </div>
                          </MenuItem>
                          :
                          <MenuItem value={f.id}>{f.name}</MenuItem>))}

          
        </Select>
      </Box>
    ),
  }));
}, [currentStoresFilePreviewData.columns, currentStoresFile]);

const [latLongs, setLatLongs] = useState([])
const [wrongLatLongs, setWrongLatLongs] = useState([])

function isValidLatLng(latitude, longitude) {
  const lat = Number(latitude);
  const lng = Number(longitude);

  return (
    latitude != '' && longitude != '' &&
    Number.isFinite(lat) &&
    Number.isFinite(lng) &&
    lat >= -90 &&
    lat <= 90 &&
    lng >= -180 &&
    lng <= 180
  );
}
function areLatLngSwapped(a, b) {
  const first = Number(a);
  const second = Number(b);

  if (!Number.isFinite(first) || !Number.isFinite(second)) {
    return false;
  }

  const normal =
    first >= -90 && first <= 90 &&
    second >= -180 && second <= 180;

  const swapped =
    first >= -180 && first <= 180 &&
    second >= -90 && second <= 90;

  return !normal && swapped;
}
const copyErrorRowsToClipboad = async () => {
  const resultArr = storesFileUpdateResults.errors.map(err => err.row)
  try {
    await navigator.clipboard.writeText(resultArr.join("\n"));
    setSnackBarClipboardOpen(true)
    
  } catch (error) {
    console.error("Failed to copy:", error);
  }
}

const [editingRowId, setEditingRowId] = useState(0)
const handleStartEditRow = (rowId) => {
  //console.log(rowId)
  const rowMode = apiRefStores.current.getRowMode(rowId);

  if (rowMode === 'view') apiRefStores.current.startRowEditMode({id: rowId,});

}
const handleDeleteStore = (storeId) => {
  setDialogConfirmDeleteStoreOpen(true)
  setDialogManageStoreId(storeId)
}

const handleStoreUpdate = async (updatedRow, originalRow) => {
  const success = await updateStore(updatedRow)
  
  setEditingRowId(originalRow.id)
  if (success) return updatedRow
  else return originalRow
}
const handleStoreUpdateError = () => {}

return (
        <>
            <DataGridPro rows={data} columns={columns}
                        loading={dataIsLoading}
                        sx={{
                          "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                            outline: "none !important",
                          },
                        }}
                        apiRef={apiRef}
                  onRowClick={(params) => { if (props.onRowClick !== undefined) props.onRowClick(params.row)}}
                  slots={{
                    noRowsOverlay: NoRowsCustomMessage,
                    loadingOverlay: CustomLoader,
                    footer: CCCustomFooter,
                  }}
                  slotProps={{
                    noRowsOverlay: {onCreateFirstDataConnectionClicked: props.onCreateFirstDataConnectionClicked},
                    footer: { counter: data.length, titleCounter: "Number of stores files" },
                  }}  
            />
      <Dialog onClose={() => handleDialogClose('abort')} open={dialogOpen}
                aria-labelledby="dialog-title"
                aria-describedby="dialog-description"
                maxWidth='xl'>
            <DialogTitle id="dialog-title" sx={{color: ccColorDarkTeal}}>{dialogData.title}</DialogTitle>
            <DialogContent>
              {!storesFileUpdating && !storesFileShowUpdateResult && 
              <div className='flex flex-col gap-y-2 text-ccColorDarkTeal'>    
                <div className='flex flex-row gap-x-8'>
                  <div className="w-64">
                    <InputText
                            displayName="Name"
                            value={currentStoresFile.name}
                            onChange={(val) => {handleStoresFileChange('name', val);}}
                            error={getErrorMessage(activeErrorList, 'name')}
                    />
                  </div>
                  <div className="w-64">
                    <InputText
                            displayName="Description"
                            value={currentStoresFile.desc}
                            onChange={(val) => {handleStoresFileChange('desc', val);}}
                    />
                  </div>
                </div>
                <div className='flex flex-row items-center gap-x-2'>
                  <FilePicker
                    accept=".csv,text/csv"
                    buttonText="Select CSV"
                    onFileSelected={handleFileSelected}
                    error={getErrorMessage(activeErrorList, 'file')}
                  />
                  {currentStoresFile.storesFileId && <div className='bg-amber-200 text-amber-600 px-2 py-1 rounded text-sm font-inter'>
                    <div><span className='font-semibold'>Important - </span>Uploading a new file will:</div>
                    <ul>
                      <li className='list-item list-disc ml-4'>Insert new stores</li>
                      <li className='list-item list-disc ml-4'>Update existing stores</li>
                      <li className='list-item list-disc ml-4'>Old stores not present in this file will be kept unchanged</li>
                    </ul>
                    </div>}
                </div>

                <div className='flex flex-row gap-x-2'>
                  <div className='w-[800px] h-[440px]'>
                    {getErrorMessage(activeErrorList, 'columnMapping')?.length > 0 && <div className=" text-sm text-red-600">
                        <div className='flex flex-row items-center gap-x-1'>
                              <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
                              <div>Please map the following fields:</div>
                        </div>
                        <ul className='list-disc'>
                          {getErrorMessage(activeErrorList, 'columnMapping').includes('storeId') && 
                          <li className='ml-8'>Store Id</li>}
                          {getErrorMessage(activeErrorList, 'columnMapping').includes('latitude') && 
                          <li className='ml-8'>Latitude</li>}
                          {getErrorMessage(activeErrorList, 'columnMapping').includes('longitude') && 
                          <li className='ml-8'>Longitude</li>}
                        </ul>
                      </div>
                    }
                    <DataGridPro rows={currentStoresFilePreviewData.rows} columns={previewColumns}
                    apiRef={apiRefStoresData}
                    disableColumnMenu
                    getRowClassName={(params) =>
                              highlightedRowIds?.includes(params.id)
                                ? 'highlighted-row'
                                : ''
                            }
                    sx={{
                      '& .highlighted-row': {
                        backgroundColor: '#FF0F0F',
                      },

                      // Preserve the highlight during hover.
                      '& .highlighted-row:hover': {
                        backgroundColor: '#FF0F0F',
                      },

                      // Optional: preserve it when the row is selected.
                      '& .highlighted-row.Mui-selected': {
                        backgroundColor: '#FF0F0F',
                      },
                      '& .highlighted-row.Mui-selected:hover': {
                        backgroundColor: '#FF0F0F',
                      },
                    }}              
                    />	 
                  </div>
                  <div className='w-[460px] border rounded px-2 py-1 text-ccColorDarkTeal font-poppins'>
                    <div className='font-semibold text-center'>Visual check</div>
                    {latLongs.length > 0 ? <div className='flex flex-col items-center gap-y-1'>
                        {highlightedRowIds?.length > 0 && <div className='text-red-700 px-2 py-1 bg-red-100 w-fit rounded text-sm'>Some latitudes, longitudes are not valid</div>}
                        <CcMapPointers points={latLongs} />
                      </div>
                      :
                      <div className='mt-2 font-inter text-sm text-gray-500'>It is extremely important that the latitude and longitude in your file are used correctly.
                      <br/><br/>Once you have mapped both latitude and longitude, you will see a map that allows to sense check your stores are in the right place.
                      </div>
                    }
                  </div>
                </div>


              </div>
              }
              {storesFileUpdating && <div className='flex flex-col gap-y-1 items-center text-ccColorDarkTeal w-[800px]'>
                <CcLoader size={96} />
                <div className='font-poppins'>Updating Stores...</div>
                </div>}
              {storesFileShowUpdateResult && <div className='flex flex-col gap-y-1 items-center text-ccColorDarkTeal w-[800px]'>
                {storesFileUpdateResults?.errors.length === 0 && <div className='bg-green-100 text-green-600 font-poppins rounded px-4 py-2'>
                    <div className='font-semibold text-lg'>Success</div>
                    <div>Stores uploaded correctly</div>
                </div>
                }
                {storesFileUpdateResults?.errors.length > 0 && <div className='text-ccColorDarkTeal'>
                    <div className='text-lg font-semibold'>File uploaded</div>
                    <div className='mt-2 text-sm'>Skipped rows:</div>
                    <div className='border rounded mt-1 h-64 overflow-auto'>
                      <div className='flex flex-row font-semibold'>
                        <div className='w-[280px] text-center'>Message</div>
                        <div className='w-[320px] text-center'>Row</div>
                      </div>
                      {storesFileUpdateResults.errors.map((err, index) => <div className={`flex flex-row text-sm text-gray-600 ${index % 2 !== 0 ? '' : 'bg-slate-200'}`}>
                        <div className='min-w-0 w-[280px] truncate'>{err.message}</div>
                        <div className='min-w-0 w-[320px] truncate font-mono'>{err.row}</div>
                      </div>)}
                    </div>
                    <div className='flex justify-end mt-1'>
                      <CcSecondaryActionButtonOutlined onClick={copyErrorRowsToClipboad}>Copy rows to clipboard</CcSecondaryActionButtonOutlined>
                    </div>
                </div>
                }

                </div>}
            </DialogContent>
          <DialogActions>
              {dialogData.showCloseButton ?
              <Button sx={{color: ccColorSecondaryPink}} onClick={() => handleDialogClose('abort')}>Close</Button>
              :
              <>
              <Button sx={{color: ccColorSecondaryPink}} onClick={() => handleDialogClose('abort')}>Cancel</Button>
              <Button sx={{color: ccColorSecondaryPink}} onClick={() => handleDialogClose('upload')} autoFocus>
                  Confirm
              </Button>
              </>
              }
          </DialogActions>

      </Dialog>

      <Dialog onClose={() => handleDialogManageStoresClose('abort')} open={dialogManageStoresOpen}
                aria-labelledby="dialog-stores"
                aria-describedby="dialog-description"
                maxWidth='xl'>
            <DialogTitle id="dialog-stores" sx={{color: ccColorDarkTeal}}>Manage stores</DialogTitle>
            <DialogContent>
              <div className='flex flex-col gap-y-2 text-ccColorDarkTeal'>    

                <div className='w-[1024px] h-[440px]'>
                  <DataGridPro rows={stores} columns={storesColumns}
                  apiRef={apiRefStores}
                  editMode="row"
                  processRowUpdate={handleStoreUpdate}
                  onProcessRowUpdateError={handleStoreUpdateError}
                  loading={storesAreLoading}
                  slots={{
                    loadingOverlay: CustomLoader,
                  }}
                  pinnedColumns={{ right: ['actions'] }}
                  disableColumnMenu
                  disableRowSelectionOnClick
                  sx={{
                      "& .MuiDataGrid-row.MuiDataGrid-row--editing": {
                        "--DataGrid-rowBackground": "#e2e8f0 !important",
                        backgroundColor: "#e2e8f0 !important",
                      },

                      "& .MuiDataGrid-row.MuiDataGrid-row--editing > .MuiDataGrid-cell": {
                        backgroundColor: "transparent !important",
                      },

                      "& .MuiDataGrid-row.MuiDataGrid-row--editing .MuiDataGrid-cell--editing": {
                        backgroundColor: "transparent !important",
                      },
                    }}
                  />	 
                </div>


              </div>

            </DialogContent>
          <DialogActions>
              <Button sx={{color: ccColorSecondaryPink}} onClick={() => handleDialogManageStoresClose('abort')}>Close</Button>
          </DialogActions>

          <Dialog onClose={() => handleDialogDeleteStoreClose('abort')} open={dialogConfirmDeleteStoreOpen}
                    aria-labelledby="dialog-stores"
                    aria-describedby="dialog-description"
                    maxWidth='xl'>
                <DialogTitle id="dialog-stores" sx={{color: ccColorDarkTeal}}>Confirm delete store</DialogTitle>
                <DialogContent>
                  <div className='flex flex-col gap-y-2 text-ccColorDarkTeal'>    
                    <div>Are you sure you want to delete store id: <span className='font-semibold'>{dialogManageStoreId}</span>?</div>

                  </div>

                </DialogContent>
              <DialogActions>
                  <Button sx={{color: ccColorSecondaryPink}} onClick={() => handleDialogDeleteStoreClose('abort')}>Cancel</Button>
                  <Button sx={{color: ccColorSecondaryPink}} onClick={() => handleDialogDeleteStoreClose('confirm')}>Confirm</Button>
              </DialogActions>

          </Dialog>

      </Dialog>

      <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={snackBarClipboardOpen}
      autoHideDuration={1500}
      onClose={handleCloseSnackBarClipboard}
      message="Copied to clipboard"
      action={SnackBarAction}
ContentProps={{
  style: {
    backgroundColor: '#333',
    color: '#fff',
  },
}}
    />
        </>

    )
}